export default __webpack_public_path__ + "static/media/spectrophotometer-info-7.b285808c.svg";